<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card>
      <!-- Avatar Row -->
      <!-- <pre>
        {{ permissionsSubMenu }}
      </pre> -->
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <div class="vx-row">
            <div class="vx-col w-2/5 mt-5">
              <validation-provider :name="$t('sections.system.dataForm.nameTh')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.system.dataForm.nameTh") }}*</label>
                <vs-input type="text" v-model="form.nameTh" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-2/5 mt-5">
              <validation-provider :name="$t('sections.system.dataForm.nameEn')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.system.dataForm.nameEn") }}</label>
                <vs-input type="text" v-model="form.nameEn" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/5 mt-5">
              <validation-provider :name="$t('sections.system.dataForm.status')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.system.dataForm.status") }}*</label>
                <v-select v-model="form.status" :clearable="false" :options="statusesOptions" name="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>

          <!-- Permissions -->
          <div class="vx-row mt-5">
            <div class="vx-col w-full">
              <div class="flex items-end px-3">
                <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
                <span class="font-medium text-lg leading-none">{{ $t('sections.system.dataForm.permissions') }}</span>
              </div>
              <vs-divider />
            </div>
          </div>

          <div class="block overflow-x-auto">
            <table class="w-full">
              <tr>
                <th class="font-semibold text-base text-left px-3 py-2" >{{ $t('sections.system.dataForm.menu') }}</th>
                <th class="font-semibold text-base text-left px-3 py-2" >{{ $t('sections.system.dataForm.subMenus') }}</th>
                <th class="font-semibold text-base text-left px-3 py-2" >{{ $t('sections.system.dataForm.visible') }}</th>
                <th class="font-semibold text-base text-left px-3 py-2" >{{ $t('sections.system.dataForm.create') }}</th>
                <th class="font-semibold text-base text-left px-3 py-2" >{{ $t('sections.system.dataForm.edit') }}</th>
                <th class="font-semibold text-base text-left px-3 py-2" >{{ $t('sections.system.dataForm.delete') }}</th>
              </tr>
              <tr v-for="(res, name) in form.permissions" :key="name">
                <td class="px-3 py-2">{{ $t(res.menu.i18n) }}</td>
                <td class="px-3 py-2">
                  {{ $t(res.i18n) }}
                  <small v-if="isAdministratorPermission(res)" class="text-muted">(เฉพาะ Administrator Root)</small>
                </td>
                <td class="px-3 py-2"><vs-checkbox v-model="res.visible" :disabled="isAdministratorPermission(res)" /></td>
                <td class="px-3 py-2"><vs-checkbox v-model="res.create" :disabled="isAdministratorPermission(res)" /></td>
                <td class="px-3 py-2"><vs-checkbox v-model="res.edit" :disabled="isAdministratorPermission(res)" /></td>
                <td class="px-3 py-2"><vs-checkbox v-model="res.delete" :disabled="isAdministratorPermission(res)" /></td>
              </tr>
            </table>
          </div>

          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="submit">{{ $t("sections.user.dataForm.action.btnSave") }}</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">{{ $t("sections.user.dataForm.action.btnReset") }}</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'
import { isAdministratorRoute } from '@/utils/administrator-routes'

const {mapActions: mapSystemActions, mapState: mapSystemFields} = createNamespacedHelpers('System')

export default {
  components: {
    vSelect,
    ValidationProvider
  },

  data () {
    return {
      form:{
        nameTh: '',
        nameEn: '',
        status: 'Enabled',
        permissions: []
      }
    }
  },
  async created () {
    const vm = this
    vm.pms ('SystemRole', 'edit', 'r')
    await vm.getSubMenus()
    await vm.getRole({form: {id: vm.$route.params.id}})

    vm.form = {
      nameTh: vm.role.nameTh,
      nameEn: vm.role.nameEn,
      status: vm.role.status,
      permissions: vm.permissionsSubMenu.map(res=> {
        var obj = vm.queryPermissionsRole(res.id)
        return vm.lockAdministratorPermission({...res, ...obj})
      }),
    }
  },
  computed: {
    ...mapSystemFields(['status', 'role']),
    ...mapGetters({
      statusesOptions :'Master/statusesOptions',
      permissionsSubMenu :'System/permissionsSubMenu',
    })
  },
  methods: {
    ...mapSystemActions(['getSubMenus', 'updateRole', 'getRole']),
    isAdministratorPermission (permission) {
      return isAdministratorRoute(permission.url)
    },
    lockAdministratorPermission (permission) {
      if (!this.isAdministratorPermission(permission)) return permission
      const enabled = this.role.type === 'root'
      return {...permission, visible: enabled, create: enabled, edit: enabled, delete: enabled}
    },
    queryPermissionsRole (subMenuID) {
      const query = this.role.permissions.filter(res=> {
        return res.subMenu.id == subMenuID
      })[0]
      return query
    },
    async submit () {
      const vm = this
      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }

        this.updateRole({
          id: vm.$route.params.id,
          form: {
            nameTh: vm.form.nameTh,
            nameEn: vm.form.nameEn,
            status: vm.form.status.value || vm.form.status,
            permissions: vm.form.permissions.map(res=>{
              return {
                subMenuID: res.subMenu.id,
                visible: res.visible,
                create: res.create,
                edit: res.edit,
                delete: res.delete
              }
            })
          },
          vm,
          redirect: "/administartor/role"
        })
      })
    },
    reset () {
      const vm = this
      vm.form = {
        nameTh: vm.role.nameTh,
        nameEn: vm.role.nameEn,
        status: vm.role.status,
        permissions: vm.permissionsSubMenu.map(res=> {
          var obj = vm.queryPermissionsRole(res.id)
          return vm.lockAdministratorPermission({...res, ...obj})
        }),
      }
    }
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>
